// @ts-nocheck
import Hotjar from '@hotjar/browser'
export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()
  if (config.public.stage !== 'live') { return }
  const siteId = config.public.hotjarId
  const hotjarVersion = 6

  Hotjar.init(siteId, hotjarVersion)
})
